import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import ElementPlus from 'element-plus'
import Pagination from '@/components/Pagination'
import hasPermission from '@/directives/permission.js'
import isPermission from '@/directives/port.js'
import elDragDialog from '@/directives/el-drag-dialog';
import { formatDateTime } from '@/utils/date.js'
import { getDictItemsByDictType } from '@/api/admin/dictItem.js'
import { dictFormat } from '@/utils/util.js'
import * as ElIconModules from '@element-plus/icons'
import 'core-js/stable'
import 'babel-polyfill'
import 'regenerator-runtime/runtime'
// 引入全局样式文件
import 'element-plus/dist/index.css'
import '@/assets/css/global.css'

const app = createApp(App)

app.directive('el-drag-dialog', elDragDialog);
app.use(store)
app.use(router)
app.use(i18n)
app.use(ElementPlus)
app.mount('#app')
import { nextTick } from 'vue'
nextTick(() => {
  document.dispatchEvent(new Event('render-event'))
})
// 全局组件挂载
app.component('Pagination', Pagination)
// 定义全局指令
app.directive('hasPermission', hasPermission())
app.directive('isPermission', isPermission())

for (const iconName in ElIconModules) {
  app.component(iconName, ElIconModules[iconName])
}

// 全局方法挂载
app.config.globalProperties.formatDateTime = formatDateTime
app.config.globalProperties.getDictItemsByDictType = getDictItemsByDictType
app.config.globalProperties.dictFormat = dictFormat
